<template>
    <div>

        <!-- FILTER START -->
        <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="outerBox filterBox">
                <div class="row">
                    <div class="col-md-3">
                        <label>Category</label>
                        <Multiselect 
                          v-model="filter.category"
                          :options="options.category.map(x => x.category)"
                          :multiple="true"
                          placeholder="All Category"
                        ></Multiselect>
                    </div>
                    <div class="col-md-3">
                        <label>Segment</label>
                        <Multiselect 
                          v-model="filter.segment"
                          :options="options.segment.map(x => x.segment)"
                          :multiple="true"
                          placeholder="All Segment"
                        ></Multiselect>
                    </div>
                    <div class="col-md-3">
                        <label>Sub Series</label>
                        <Multiselect 
                          v-model="filter.subSeries"
                          :options="options.subSeries.map(x => x.subSeries)"
                          :multiple="true"
                          placeholder="All Sub Series"
                        ></Multiselect>
                    </div>
                    <div class="col-md-3">
                        <label>Type</label>
                        <Multiselect 
                          v-model="filter.type"
                          :options="options.type.map(x => x.type)"
                          :multiple="true"
                          placeholder="All Type"
                        ></Multiselect>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label>Code</label>
                        <Multiselect 
                          v-model="filter.code"
                          :options="options.code.map(x => x.codeMarket)"
                          :multiple="true"
                          placeholder="All Code"
                        ></Multiselect>
                    </div>
                    <div class="col-md-3 offset-md-6" style="display: flex; flex-direction: column-reverse; padding-top:20px">
                        <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
                    </div>
                </div>
            </div>
        </panel>
        <!-- FILTER END -->

		<h3 class="mt-2 mb-3">Vehicle Type Settings</h3>

        <vue-universal-table
            api_url="/api/setting/vehicle-type"
            :filter="filter"
            :fields="vue_universal_table.fields"
            :buttons="vue_universal_table.buttons"
            :update="vue_universal_table.update"
            :special_buttons="['uploadFile','newVehicleType']"
            @onNewVehicleType="modal.new = true"
            @onUploadFile="modal.upload = true"
            @onEdit="editVehicleType"
        ></vue-universal-table>

        <cu-vehicle-type
            v-if="modal.new || modal.edit"
            :data="modal.edit ? modal.editData : null"
            @refreshData="refreshData"
            @closeModal="modal.new = false; modal.edit = false;"
        ></cu-vehicle-type>


        <ModalUpload 
            v-if="modal.upload"
            @closeModal="modal.upload = false"
            @onFinish="vue_universal_table.update++"
        />

    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    import cuVehicleType from './children/CUVehicleType'
    import ModalUpload from './children/ModalUpload.vue'

    export default {
        data () {
            return {
                mobile : this.isMobile(),
                modal : {
                    new : false,
                    edit : false,
                    editData : null,
                    upload : false
                },
                filter : {
                    category : [],
                    segment : [],
                    subSeries : [],
                    type : [],
                    code : [],
                },
                options : {
                    category : this.$store.getters.getSimpleCategory,
                    segment : this.$store.getters.getSimpleSegment(),
                    subSeries : this.$store.getters.getSimpleSubSeries(),
                    type : this.$store.getters.getSimpleType(),
                    code : this.$store.getters.getSimpleCodeMarket()
                },
                vue_universal_table : {
                    fields : [
                        {title:'Name', variable:'name'},
                        {title:'Commercial Name', variable:'commercial_name'},
                        {title:'Category', variable:'category'},
                        {title:'Segment', variable:'segment'},
                        {title:'Sub-series', variable:'sub_series'},
                        {title:'Type', variable:'type'},
                        {title:'Code', variable:'code'},
                        {title:'Manufacturer Year', variable:'manufacture_year'},
                        {title:'Assembled Year', variable:'assembled_year'}
                    ],
                    buttons : [
                        {title:'Edit', class:'btn-outline-primary fas fa-edit'}
                    ],
                    update : 0,
                },
            }
        },
        components : {
            Multiselect,
            cuVehicleType,
            ModalUpload
        },
        mounted () {
            // console.log(this.$store.getters.getSimpleCodeMarket());
        },
        watch : {
            'filter.category' () {
                this.options.segment = this.$store.getters.getSimpleSegment(this.filter.category);
                this.filter.segment.splice(0);

                this.options.subSeries = this.$store.getters.getSimpleSubSeries(this.filter.category, this.filter.segment);
                this.filter.subSeries.splice(0);

                this.options.type = this.$store.getters.getSimpleType(this.filter.category, this.filter.segment, this.filter.subSeries);
                this.filter.type.splice(0);

                this.options.code = this.$store.getters.getSimpleCodeMarket(this.filter.category, this.filter.segment, this.filter.subSeries, this.filter.type);
                this.filter.code.splice(0);
            },
            'filter.segment' () {
                this.options.subSeries = this.$store.getters.getSimpleSubSeries(this.filter.category, this.filter.segment);
                this.filter.subSeries.splice(0);

                this.options.type = this.$store.getters.getSimpleType(this.filter.category, this.filter.segment, this.filter.subSeries);
                this.filter.type.splice(0);

                this.options.code = this.$store.getters.getSimpleCodeMarket(this.filter.category, this.filter.segment, this.filter.subSeries, this.filter.type);
                this.filter.code.splice(0);
            },
            'filter.subSeries' () {
                this.options.type = this.$store.getters.getSimpleType(this.filter.category, this.filter.segment, this.filter.subSeries);
                this.filter.type.splice(0);

                this.options.code = this.$store.getters.getSimpleCodeMarket(this.filter.category, this.filter.segment, this.filter.subSeries, this.filter.type);
                this.filter.code.splice(0);
            },
            'filter.type' () {
                this.options.code = this.$store.getters.getSimpleCodeMarket(this.filter.category, this.filter.segment, this.filter.subSeries, this.filter.type);
                this.filter.code.splice(0);
            }
        },
        methods : {
            editVehicleType (data) {
                this.modal.editData = JSON.parse(data);
                this.modal.edit = true;
            },
            refreshData () {
                this.vue_universal_table.update++;

                setTimeout(()=>{
                    this.options.code = this.$store.getters.getSimpleCodeMarket(this.filter.category, this.filter.segment, this.filter.subSeries, this.filter.type);
                    this.filter.code.splice(0);
                },1000);
            },
        }
    }
</script>

<style scoped>

</style>